import React from 'react';
import { ArrowLeftIcon, ShieldCheckIcon } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
export function PrivacyPolicy() {
  const navigate = useNavigate();
  return <div className="w-full min-h-screen bg-[#F6F8FB]" data-id="element-291">
      {/* Header */}
      <nav className="bg-white shadow-sm" data-id="element-292">
        <div className="max-w-4xl mx-auto px-6 py-4" data-id="element-293">
          <button onClick={() => navigate('/')} className="flex items-center gap-2 text-[#0B1220] hover:text-[#3B82F6] transition-colors" data-id="element-294">
            <ArrowLeftIcon className="w-5 h-5" data-id="element-295" />
            <span className="font-medium" data-id="element-296">Back to Home</span>
          </button>
        </div>
      </nav>
      {/* Content */}
      <div className="max-w-4xl mx-auto px-6 py-12" data-id="element-297">
        <div className="flex items-center gap-3 mb-6" data-id="element-298">
          <div className="w-12 h-12 bg-gradient-to-br from-[#3B82F6] to-[#10B981] rounded-lg flex items-center justify-center" data-id="element-299">
            <ShieldCheckIcon className="w-7 h-7 text-white" data-id="element-300" />
          </div>
          <h1 className="text-4xl font-bold text-[#0B1220]" data-id="element-301">Privacy Policy</h1>
        </div>
        <div className="bg-white rounded-2xl shadow-sm p-8 space-y-8" data-id="element-302">
          <div className="text-sm text-gray-500 mb-6" data-id="element-303">
            Last Updated: January 2025
          </div>
          <section data-id="element-304">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-305">
              1. Introduction
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-306">
              G.S. HRC ("we," "our," or "us") is committed to protecting the
              privacy and security of your personal information. This Privacy
              Policy explains how we collect, use, disclose, and safeguard your
              information when you visit our website or engage with our
              business-to-business services.
            </p>
          </section>
          <section data-id="element-307">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-308">
              2. Information We Collect
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3" data-id="element-309">
              We collect information that you provide directly to us, including:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-310">
              <li data-id="element-311">
                Business contact information (name, email, phone number, company
                name)
              </li>
              <li data-id="element-312">Business registration and verification documents</li>
              <li data-id="element-313">Order and transaction information</li>
              <li data-id="element-314">Communication preferences and correspondence</li>
              <li data-id="element-315">
                Technical information (IP address, browser type, device
                information)
              </li>
            </ul>
          </section>
          <section data-id="element-316">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-317">
              3. How We Use Your Information
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3" data-id="element-318">
              We use the information we collect to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-319">
              <li data-id="element-320">Process and fulfill your business orders</li>
              <li data-id="element-321">Verify your business credentials and eligibility</li>
              <li data-id="element-322">Communicate with you about products, services, and orders</li>
              <li data-id="element-323">Improve our website and services</li>
              <li data-id="element-324">Comply with legal obligations and prevent fraud</li>
              <li data-id="element-325">Send marketing communications (with your consent)</li>
            </ul>
          </section>
          <section data-id="element-326">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-327">
              4. Information Sharing
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3" data-id="element-328">
              We do not sell your personal information. We may share your
              information with:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-329">
              <li data-id="element-330">Service providers who assist in our business operations</li>
              <li data-id="element-331">Manufacturers and suppliers to fulfill orders</li>
              <li data-id="element-332">Legal authorities when required by law</li>
              <li data-id="element-333">Business partners with your explicit consent</li>
            </ul>
          </section>
          <section data-id="element-334">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-335">
              5. Data Security
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-336">
              We implement appropriate technical and organizational security
              measures to protect your personal information against unauthorized
              access, alteration, disclosure, or destruction. However, no method
              of transmission over the internet is 100% secure.
            </p>
          </section>
          <section data-id="element-337">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-338">
              6. Data Retention
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-339">
              We retain your personal information for as long as necessary to
              fulfill the purposes outlined in this Privacy Policy, unless a
              longer retention period is required by law.
            </p>
          </section>
          <section data-id="element-340">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-341">
              7. Your Rights
            </h2>
            <p className="text-gray-700 leading-relaxed mb-3" data-id="element-342">
              You have the right to:
            </p>
            <ul className="list-disc list-inside space-y-2 text-gray-700 ml-4" data-id="element-343">
              <li data-id="element-344">Access and receive a copy of your personal information</li>
              <li data-id="element-345">Request correction of inaccurate information</li>
              <li data-id="element-346">Request deletion of your information</li>
              <li data-id="element-347">Object to processing of your information</li>
              <li data-id="element-348">Withdraw consent at any time</li>
            </ul>
          </section>
          <section data-id="element-349">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-350">
              8. International Transfers
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-351">
              As we operate across EU, Middle East, and East Asia, your
              information may be transferred to and processed in countries other
              than your own. We ensure appropriate safeguards are in place for
              such transfers.
            </p>
          </section>
          <section data-id="element-352">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-353">
              9. Cookies and Tracking
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-354">
              We use cookies and similar tracking technologies to improve your
              browsing experience and analyze website traffic. You can control
              cookie preferences through your browser settings.
            </p>
          </section>
          <section data-id="element-355">
            <h2 className="text-2xl font-bold text-[#0B1220] mb-4" data-id="element-356">
              10. Contact Us
            </h2>
            <p className="text-gray-700 leading-relaxed" data-id="element-357">
              If you have questions about this Privacy Policy or wish to
              exercise your rights, please contact us at:
            </p>
            <div className="mt-4 p-4 bg-gray-50 rounded-lg" data-id="element-358">
              <p className="text-gray-700 font-medium" data-id="element-359">G.S. HRC</p>
              <p className="text-gray-700" data-id="element-360">Email: contact@grapeskinhrc.com</p>
            </div>
          </section>
        </div>
      </div>
    </div>;
}